import React from 'react';
import '../styles/Founder.css';

const Founder = () => {
  return (
    <section id="founder" className="founder">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Meet the Founder</h2>
          <p className="section-subtitle">The vision and expertise behind Tallhaven</p>
        </div>

        <div className="founder-content">
          <div className="founder-card">
            <div className="founder-avatar">
              <div className="avatar-placeholder">SM</div>
            </div>
            <div className="founder-info">
              <h3 className="founder-name">Seth Moffat</h3>
              <p className="founder-role">Founder &amp; Lead Developer</p>
              <div className="founder-divider"></div>
              <p className="founder-bio">
                Seth Moffat is the founder and lead developer of Tallhaven, bringing hands-on
                technical expertise and entrepreneurial vision to every project. With a passion
                for building modern, reliable software, Seth established Tallhaven to deliver
                high-quality digital solutions that help businesses grow and succeed in an
                ever-evolving technological landscape.
              </p>
              <p className="founder-bio">
                Seth drives the company's technical direction, working closely with clients to
                understand their needs and crafting solutions that are both innovative and practical.
              </p>
              <a
                href="https://www.linkedin.com/in/sethmoffat"
                target="_blank"
                rel="noopener noreferrer"
                className="founder-linkedin"
              >
                Connect on LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
